'use strict';
define(['app', 'angular'], function (app, angular) {
    app.service('stAlertLimitService', stAlertLimitService);
    stAlertLimitService.$inject = [
        '$q', '$compile', '$document', '$location', '$rootScope', '$templateRequest', '$timeout'
    ];

    function stAlertLimitService($q, $compile, $document, $location, $rootScope, $templateRequest, $timeout) {
        var templateUrl = 'app/components/st-alert-limit/st-alert-limit.service.html';

        return {
            open: open
        };

        function open(url, error) {
            if ($rootScope.alertLimitIsOpen) {
                return $q.resolve();
            }

            $rootScope.alertLimitIsOpen = true;

            var dfd = $q.defer();
            var body = $document[0].body;
            var scope = $rootScope.$new(true);
            var element = null;
            var closed = false;
            var previousFocus = $document[0].activeElement;

            scope.error = error || {};
            scope.url = url;
            scope.canClose = !!(error && error.canClose);
            scope.ariaLabel = scope.error.ariaLabel ||
                (url === 'auth-login' ? 'Account' : 'Application message');
            scope.close = close;

            function close() {
                if (closed) return;
                closed = true;
                $rootScope.alertLimitIsOpen = false;
                $location.hash(null);
                $document.off('keydown', handleKeydown);
                body.classList.remove('sto-modal-open');
                if (scope) scope.$destroy();
                if (element) element.remove();
                if (previousFocus && previousFocus.focus) {
                    $timeout(function () {
                        previousFocus.focus();
                    }, 0, false);
                }
                dfd.resolve();
            }

            function focusableElements() {
                if (!element) return [];
                return Array.prototype.filter.call(
                    element[0].querySelectorAll(
                        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), ' +
                        'textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
                    ),
                    function (node) {
                        return node.offsetWidth || node.offsetHeight || node.getClientRects().length;
                    }
                );
            }

            function handleKeydown(event) {
                if (!element) return;
                if (event.key === 'Escape' && scope.canClose) {
                    event.preventDefault();
                    $rootScope.$evalAsync(close);
                    return;
                }
                if (event.key !== 'Tab') return;
                var focusable = focusableElements();
                if (!focusable.length) {
                    event.preventDefault();
                    element[0].querySelector('.sto-modal__dialog').focus();
                    return;
                }
                var first = focusable[0];
                var last = focusable[focusable.length - 1];
                if (event.shiftKey && $document[0].activeElement === first) {
                    event.preventDefault();
                    last.focus();
                } else if (!event.shiftKey && $document[0].activeElement === last) {
                    event.preventDefault();
                    first.focus();
                }
            }

            $templateRequest(templateUrl)
                .then(function (html) {
                    if (closed) return;
                    element = $compile(angular.element(html))(scope);
                    body.appendChild(element[0]);
                    body.classList.add('sto-modal-open');
                    $document.on('keydown', handleKeydown);
                    $timeout(function () {
                        var dialog = body.querySelector('.sto-modal__dialog');
                        if (dialog && dialog.focus) dialog.focus();
                    }, 0, false);
                })
                .catch(function (templateError) {
                    console.error('Unable to open alert dialog', templateError);
                    close();
                });

            return dfd.promise;
        }
    }
});
